import { PText } from "@porsche-design-system/components-react"
import type { ConditionAndServiceChange } from "@slfinrtl/ui-bff-routes"
import { FieldWrapper } from "../FieldWrapper"
import { useConditionAndServiceChanges } from "./useConditionAndServiceChanges"

export interface ConditionAndServiceChangeView {
	conditionAndService?: ConditionAndServiceChange
}

export interface ConditionAndServiceChangesProps {
	view: ConditionAndServiceChangeView
}

export const ConditionAndServiceChanges = ({ view }: ConditionAndServiceChangesProps) => {
	const { conditionAndService } = view

	const changes = useConditionAndServiceChanges(conditionAndService)

	return changes.map(({ label, value }, i) => (
		<FieldWrapper key={i}>
			<PText>{label}</PText>
			<PText>{value}</PText>
		</FieldWrapper>
	))
}
